import { Component, inject, OnInit, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import * as fromApp from './store/app.reducer';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router, RouterOutlet } from '@angular/router';
import { HeaderComponent } from './header/header.component';
import { BottomNavComponent } from './bottom-nav/bottom-nav.component';
import { FooterComponent } from './footer/footer.component';
import { CookieConsentComponent } from './shared/cookie-consent/cookie-consent.component';
import { GDPRConsentDialogComponent } from './shared/gdpr-consent/gdpr-consent-dialog.component';
import { ToastModule } from 'primeng/toast';
import { autoLogin } from './auth/store/auth.actions';
import * as ObservationActions from './observations/store/observation.actions';
import { filter, skipWhile, take, Subscription } from 'rxjs';
import { LoadingService } from './services/loading.service';
import { ProgressBarModule } from 'primeng/progressbar';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, HeaderComponent, BottomNavComponent, FooterComponent, CookieConsentComponent, GDPRConsentDialogComponent, ToastModule, ProgressBarModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit, OnDestroy {
  private store = inject(Store<fromApp.AppState>);
  private router = inject(Router);
  protected loading = inject(LoadingService);
  private routerSub?: Subscription;

  ngOnInit(): void {
    this.store.dispatch(autoLogin());

    // Track router navigation for loading indicator
    this.routerSub = this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.loading.setNavigating(true);
      } else if (
        event instanceof NavigationEnd ||
        event instanceof NavigationCancel ||
        event instanceof NavigationError
      ) {
        this.loading.setNavigating(false);
      }
    });

    // Only fetch observations after autoLogin has been attempted and if user exists
    this.store.select('auth')
      .pipe(
        skipWhile((state) => !state.autoLoginAttempted),
        take(1),
        filter((state) => !!state.user)
      )
      .subscribe(() => {
        this.store.dispatch(ObservationActions.fetchObservations({}));
      });
  }

  ngOnDestroy(): void {
    this.routerSub?.unsubscribe();
  }
}
